function Counter1_1() {
  return <circle cx="8" cy="8" r="2.5" fill="#404040" />;
}

export default Counter1_1;
